module.exports = __webpack_public_path__ + "static/logo-ded4c56b6c794430a952fd19c2759b28.png";